import React, {useState, useEffect, useRef} from 'react'
import {useNavigate} from 'react-router-dom'
import {pdf} from '@react-pdf/renderer'
import {KTIcon} from '../../../../../_websoft/helpers'
import {createNajavaUtovara, getNajavaUtovara} from '../../../../api/proizvodnja'
import {vozaciSearch} from '../../../../api/partneri'
import notifyToast from '../../../../components/Toast/Toast'
import NajavaUtovaraPdf from './NajavaUtovaraPdf'
import {getNajavaUtovaraPdfData} from './najavaUtovaraPdfData'
import ThermoboardRobaTable from './ThermoboardRobaTable'

const getResponseRows = (response: any) => {
  if (Array.isArray(response)) return response
  if (Array.isArray(response?.data)) return response.data
  if (Array.isArray(response?.data?.data)) return response.data.data
  return []
}

type Props = {
  showModal: boolean
  onClose: () => void
  onCreated?: () => void
  initialKupac: string
  groupedRobaByTruck: any[][]
  setGroupedRobaByTruck: React.Dispatch<React.SetStateAction<any[][]>>
  binsPacked?: any[]
  manual?: boolean
}

const NajavaUtovaraModal = ({
  showModal,
  onClose,
  onCreated,
  initialKupac,
  groupedRobaByTruck,
  setGroupedRobaByTruck,
  binsPacked = [],
  manual = false,
}: Props) => {
  const navigate = useNavigate()
  const [kupac, setKupac] = useState(initialKupac)
  const [selectedTruckIndex, setSelectedTruckIndex] = useState(0)
  const [saving, setSaving] = useState(false)
  const savingRef = useRef(false)
  const totalKamiona = groupedRobaByTruck.length
  const bin_data = binsPacked[0]?.bin_data ?? {}
  const groupedRoba = groupedRobaByTruck[selectedTruckIndex] ?? []
  useEffect(() => {
    if (showModal) setSelectedTruckIndex(0)
  }, [showModal])
  const [kontaktOsoba, setKontaktOsoba] = useState('')

  const [vozacIme, setVozacIme] = useState('')
  const [vozacFirma, setVozacFirma] = useState('')
  const [vozacTel, setVozacTel] = useState('')
  const [selectedVozac, setSelectedVozac] = useState<any>(null)
  const [vozaciOptions, setVozaciOptions] = useState<any[]>([])
  const [vozaciLoading, setVozaciLoading] = useState(false)
  const [vozaciSearchTouched, setVozaciSearchTouched] = useState(false)

  const [regKamion, setRegKamion] = useState('')
  const [regPrikolica, setRegPrikolica] = useState('')

  const [datumUtovara, setDatumUtovara] = useState('')
  const [vrijemeUtovara, setVrijemeUtovara] = useState('')

  const [granicniPrelaz, setGranicniPrelaz] = useState('')
  const [brojPasosa, setBrojPasosa] = useState('')

  const [emailDokumentacija, setEmailDokumentacija] = useState('')

  const [napomene, setNapomene] = useState('')

  const [adresaIstovara, setAdresaIstovara] = useState('')
  const [istovar1, setIstovar1] = useState('')
  const [istovar1Kontakt, setIstovar1Kontakt] = useState('')
  const [istovar2, setIstovar2] = useState('')
  const [istovar2Kontakt, setIstovar2Kontakt] = useState('')

  const [kontaktIstovar, setKontaktIstovar] = useState('')
  const [telefonIstovar, setTelefonIstovar] = useState('')

  const [ugovorenaCijenaBam, setUgovorenaCijenaBam] = useState('')
  const [ugovorenaCijenaEur, setUgovorenaCijenaEur] = useState('')
  const [dodatniUtovarRobe, setDodatniUtovarRobe] = useState('')
  const [brojNalogaDodatniUtovarRobe, setBrojNalogaDodatniUtovarRobe] = useState('')
  const [transport, setTransport] = useState('')
  const [fakturisatiTransport, setFakturisatiTransport] = useState('')
  const [fakturisatiTransportNalog, setFakturisatiTransportNalog] = useState('')
  const [carisnkiPostupak, setCarisnkiPostupak] = useState('')

  const cijenaTransportaKurs = 1.95

  // ----------------------------------------------------
  // EMAIL HELPERS
  // ----------------------------------------------------

  const toggleEmail = (email: string) => {
    const existingEmails = emailDokumentacija
      .split(',')
      .map((e) => e.trim())
      .filter(Boolean)

    if (existingEmails.includes(email)) {
      const filtered = existingEmails.filter((e) => e !== email)

      setEmailDokumentacija(filtered.join(', '))

      return
    }

    setEmailDokumentacija([...existingEmails, email].join(', '))
  }

  // ----------------------------------------------------
  // PREDEFINED CONTACTS
  // ----------------------------------------------------

  const kontaktOsobe = [
    {
      ime: 'Mersiha Isanović',
      email: 'mersiha@alternativa.ba',
      telefon: '+38761503295',
    },
    {
      ime: 'Igbala Gudžević',
      email: 'igbala@alternativa.ba',
      telefon: '+38761206286',
    },
    {
      ime: 'Husein Al-Badawi',
      email: 'husein@alternativa.ba',
      telefon: '+38761646008',
    },
    {
      ime: 'Mirza M Lemeš',
      email: 'mirza@alternativa.ba',
      telefon: '+38761528151',
    },
    {
      ime: 'Mirza R Lemeš',
      email: 'mirza.r@alternativa.ba',
      telefon: '+38766708455',
    },
    {
      ime: 'Semir Fazlić',
      email: 'semir@alternativa.ba',
      telefon: '+3876161339031',
    },
    {
      ime: 'Kenan Musinbegović',
      email: 'kenan@alternativa.ba',
      telefon: '+3876161339716',
    },
    {
      ime: 'Ivana Erić',
      email: 'ivana@alternativa.co.rs',
      telefon: '+381695522137',
    },
    {
      ime: 'Biljana Kojić',
      email: 'biljana@alternativa.rs',
      telefon: '+381695551560',
    },
    {
      ime: 'Luka Kojić',
      email: 'luka@alternativa.rs',
      telefon: '+38162267230',
    },
    {
      ime: 'Danijela Bozoljac',
      email: 'danijela@alternativa.co.rs',
      telefon: '+381695559263',
    },
  ]

  const setKontakt = (kontakt: any) => {
    setKontaktOsoba(`${kontakt.ime}${kontakt.telefon ? ` ${kontakt.telefon}` : ''}`)

    if (kontakt.email) {
      toggleEmail(kontakt.email)
    }
  }

  useEffect(() => {
    const search = vozacIme.trim()

    if (!showModal || selectedVozac || search.length < 3) {
      setVozaciOptions([])
      setVozaciLoading(false)
      setVozaciSearchTouched(search.length >= 3)
      return
    }

    setVozaciLoading(true)
    setVozaciSearchTouched(true)

    const timeout = setTimeout(async () => {
      try {
        const response = await vozaciSearch({search})
        setVozaciOptions(getResponseRows(response))
      } catch (error: any) {
        console.error(error)
        setVozaciOptions([])
        notifyToast(false, error?.response?.data?.message ?? 'Greska prilikom pretrage vozaca.')
      } finally {
        setVozaciLoading(false)
      }
    }, 300)

    return () => clearTimeout(timeout)
  }, [selectedVozac, vozacIme, showModal])

  const selectVozac = (vozac: any) => {
    setSelectedVozac(vozac)
    setVozacIme(vozac?.ImePrezimeVozaca ?? '')
    setVozacFirma(vozac?.VozacFirma ?? vozac?.Firma ?? vozac?.PartnerNaziv ?? '')
    setVozacTel(vozac?.PartnerMobitel ?? '')
    setRegKamion(vozac?.RegistracijaKamiona ?? vozac?.Registracija ?? '')
    setRegPrikolica(vozac?.RegistracijaPrikolice ?? '')
    setBrojPasosa(vozac?.BrojDokumenta ?? '')
    setVozaciOptions([])
  }

  const clearSelectedVozac = () => {
    setSelectedVozac(null)
    setVozacIme('')
    setVozacFirma('')
    setVozaciOptions([])
    setVozaciSearchTouched(false)
  }

  const formatCalculatedPrice = (value: number) => {
    if (!Number.isFinite(value)) {
      return ''
    }

    return value.toFixed(2)
  }

  const handleUgovorenaCijenaBamChange = (value: string) => {
    setUgovorenaCijenaBam(value)

    const numericValue = Number(value)

    setUgovorenaCijenaEur(
      value && !isNaN(numericValue)
        ? formatCalculatedPrice(numericValue / cijenaTransportaKurs)
        : ''
    )
  }

  const handleUgovorenaCijenaEurChange = (value: string) => {
    setUgovorenaCijenaEur(value)

    const numericValue = Number(value)

    setUgovorenaCijenaBam(
      value && !isNaN(numericValue)
        ? formatCalculatedPrice(numericValue * cijenaTransportaKurs)
        : ''
    )
  }

  // ----------------------------------------------------
  // PDF DATA
  // ----------------------------------------------------

  const pdfData = {
    kupac,

    kontaktOsoba,

    roba: groupedRoba,

    vozacIme,
    vozacFirma,
    vozacTel,

    regKamion,
    regPrikolica,

    datumUtovara,
    vrijemeUtovara,

    granicniPrelaz,
    brojPasosa,

    emailDokumentacija,

    napomene,

    adresaIstovara,
    istovar1,
    istovar1Kontakt,
    istovar2,
    istovar2Kontakt,
    kontaktIstovar,
    telefonIstovar,

    ugovorenaCijenaBam,
    ugovorenaCijenaEur,
    dodatniUtovarRobe,
    brojNalogaDodatniUtovarRobe,
    transport,
    fakturisatiTransport,
    fakturisatiTransportNalog,
    carisnkiPostupak,
  }
  const generatePdf = async () => {
    if (savingRef.current) return
    if (manual && !kupac.trim()) {
      notifyToast(false, 'Naziv kupca je obavezan.')
      return
    }
    if (
      manual &&
      (groupedRoba.length === 0 || groupedRoba.some((row) => !String(row.brojNaloga ?? '').trim()))
    ) {
      notifyToast(false, 'Unesite broj naloga za svaku stavku robe.')
      return
    }
    if (!datumUtovara) {
      notifyToast(false, 'Datum utovara je obavezan.')

      return
    }

    if (groupedRobaByTruck.some((truckRows) => truckRows.some((item: any) => !item.istovar))) {
      notifyToast(false, 'Odaberi istovar je obavezan za sve stavke.')

      return
    }

    savingRef.current = true
    setSaving(true)
    try {
      for (let truckIndex = 0; truckIndex < groupedRobaByTruck.length; truckIndex++) {
        const truckRows = groupedRobaByTruck[truckIndex].map((row) => ({
          ...row,
          paketi: Array.isArray(row.paketi)
            ? row.paketi
            : String(row.paketi ?? '')
                .split(',')
                .map((value) => value.trim())
                .filter(Boolean),
        }))
        const truckBinData = binsPacked[truckIndex]?.bin_data ?? bin_data
        const payload = {
          kupac,

          kontaktOsoba,

          vozacIme,
          VozacFirma: vozacFirma,
          vozacTel,

          regKamion,
          regPrikolica,

          datumUtovara,
          vrijemeUtovara,

          granicniPrelaz,
          brojPasosa,

          emailDokumentacija,

          napomene,
          napomena: napomene,

          adresaIstovara,
          kontaktIstovar,
          telefonIstovar,

          DodatniUtovar: dodatniUtovarRobe === 'DA',
          UgovorenaCijenaTransportaKM: ugovorenaCijenaBam,
          UgovorenaCijenaTransportaEUR: ugovorenaCijenaEur,
          DodatniUtovarNalozi: brojNalogaDodatniUtovarRobe,
          Transport: transport,
          FakturisatiTransport: fakturisatiTransport === 'DA',
          FakturisatiTransportNalog: fakturisatiTransportNalog,
          CarisnkiPostupak: carisnkiPostupak,

          sirinaPrikolice: truckBinData.w,
          visinaPrikolice: truckBinData.h,
          duzinaPrikolice: truckBinData.d,

          stavke: truckRows.map((item: any) => ({
            brojNaloga: item.brojNaloga,
            stavka: item.stavka,
            brojPonude: item.brojPonude,
            sifraArtikla: item.sifra,
            boja: item.boja,
            brojPaketa: item.paketi.join(', '),
            napomena: item.napomena ?? '',
            Istovar: item.istovar ?? '',
            Istovar1: istovar1,
            KontaktIstovar1: istovar1Kontakt,
            Istovar2: istovar2,
            KontaktIstovar2: istovar2Kontakt,
          })),
        }

        const response = await createNajavaUtovara(payload)
        const idNajaveUtovara =
          response?.data?.Id ?? response?.data?.id ?? response?.Id ?? response?.id
        let pdfNajavaData = getNajavaUtovaraPdfData({
          ...pdfData,
          roba: truckRows,
          kamion: truckIndex + 1,
          ukupnoKamiona: totalKamiona,
          idNajaveUtovara,
        })

        if (idNajaveUtovara) {
          try {
            const detailsResponse = await getNajavaUtovara(idNajaveUtovara)
            const detailsData =
              detailsResponse?.data?.data ?? detailsResponse?.data ?? detailsResponse

            pdfNajavaData = getNajavaUtovaraPdfData(detailsData, pdfNajavaData)
          } catch (error) {
            console.error(error)
          }
        }

        try {
          const blob = await pdf(<NajavaUtovaraPdf data={pdfNajavaData} />).toBlob()
          const url = URL.createObjectURL(blob)

          const pdfWindow = window.open(url, '_blank')
          if (!pdfWindow) {
            const link = document.createElement('a')
            link.href = url
            link.download = 'Najava_utovara_' + (idNajaveUtovara ?? truckIndex + 1) + '.pdf'
            link.click()
          }
          setTimeout(() => URL.revokeObjectURL(url), 60000)
        } catch (error) {
          console.error(error)
          notifyToast(
            false,
            'Najava je sačuvana, ali PDF nije generisan. PDF možete ponovo otvoriti iz liste najava.'
          )
        }
      }

      onCreated?.()
      onClose()

      notifyToast(true, `Kreirano najava utovara: ${groupedRobaByTruck.length}.`)
    } catch (error: any) {
      console.error(error)

      notifyToast(
        false,
        error?.response?.data?.message ?? 'Greška prilikom kreiranja najave utovara.'
      )
    } finally {
      savingRef.current = false
      setSaving(false)
    }
  }

  return (
    <>
      {showModal && (
        <>
          <div
            className='modal fade show d-block'
            tabIndex={-1}
            role='dialog'
            aria-modal='true'
            aria-labelledby='najava-utovara-title'
            style={{
              background: 'rgba(0,0,0,0.5)',
            }}
          >
            <div className='modal-dialog modal-xl'>
              <div className='modal-content'>
                {/* HEADER */}

                <div className='modal-header'>
                  <h2 id='najava-utovara-title' className='fw-bolder'>
                    Najava utovara{manual ? ' — Thermoboard' : ''}
                  </h2>

                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-active-color-primary'
                    aria-label='Zatvori'
                    onClick={onClose}
                    disabled={saving}
                  >
                    <KTIcon iconName='cross' className='fs-1' />
                  </button>
                </div>

                {/* BODY */}

                <fieldset className='modal-body border-0 m-0' disabled={saving}>
                  <div className='row g-6'>
                    {/* ------------------------------------------------ */}
                    {/* KUPAC */}
                    {/* ------------------------------------------------ */}

                    {totalKamiona > 1 && (
                      <div className='col-md-12'>
                        <div className='alert alert-info py-3 mb-4'>
                          Bice kreirano {totalKamiona} najava utovara za {totalKamiona} kamiona.
                        </div>
                        <label className='form-label fw-bold'>Kamion</label>
                        <select
                          className='form-control'
                          value={selectedTruckIndex}
                          onChange={(e) => setSelectedTruckIndex(Number(e.target.value))}
                        >
                          {binsPacked.map((_: any, index: number) => (
                            <option value={index} key={index}>
                              Kamion {index + 1} od {totalKamiona}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className='col-md-12'>
                      <label className='form-label fw-bold'>Naziv kupca</label>

                      <input
                        aria-label='Naziv kupca'
                        aria-required={manual}
                        type='text'
                        className='form-control'
                        value={kupac}
                        readOnly={!manual}
                        onChange={(e) => setKupac(e.target.value)}
                      />
                    </div>

                    {/* ------------------------------------------------ */}
                    {/* KONTAKT */}
                    {/* ------------------------------------------------ */}

                    <div className='col-md-12'>
                      <label className='form-label fw-bold'>
                        Alternativa - Kontakt osoba i tel
                      </label>

                      <input
                        type='text'
                        className='form-control'
                        value={kontaktOsoba}
                        onChange={(e) => setKontaktOsoba(e.target.value)}
                      />

                      <div className='mt-3 d-flex gap-3 flex-wrap'>
                        {kontaktOsobe.map((kontakt, index) => (
                          <button
                            key={index}
                            type='button'
                            className='btn btn-light-primary btn-sm'
                            onClick={() => setKontakt(kontakt)}
                          >
                            {kontakt.ime}
                            {kontakt.telefon ? ` - ${kontakt.telefon}` : ''}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Adresa Istovara 1</label>

                      <input
                        type='text'
                        className='form-control'
                        value={istovar1}
                        onChange={(e) => setIstovar1(e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Istovar 1 Kontakt</label>

                      <input
                        type='text'
                        className='form-control'
                        placeholder='Ime i broj telefona'
                        value={istovar1Kontakt}
                        onChange={(e) => setIstovar1Kontakt(e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Adresa Istovara 2</label>

                      <input
                        type='text'
                        className='form-control'
                        value={istovar2}
                        onChange={(e) => setIstovar2(e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Istovar 2 Kontakt</label>

                      <input
                        type='text'
                        className='form-control'
                        placeholder='Ime i broj telefona'
                        value={istovar2Kontakt}
                        onChange={(e) => setIstovar2Kontakt(e.target.value)}
                      />
                    </div>

                    {/* ------------------------------------------------ */}
                    {/* ROBA */}
                    {/* ------------------------------------------------ */}

                    <div className='col-md-12'>
                      <h3 className='fw-bolder mb-5'>Informacije o robi</h3>
                      {totalKamiona > 1 && (
                        <div className='alert alert-primary py-3'>
                          Prikazane su stavke za kamion {selectedTruckIndex + 1} od {totalKamiona}.
                          Najava ce biti kreirana za svaki kamion posebno.
                        </div>
                      )}

                      {manual ? (
                        <ThermoboardRobaTable
                          rows={groupedRoba}
                          onChange={(rows) => setGroupedRobaByTruck([rows])}
                        />
                      ) : (
                        <div className='table-responsive'>
                          <table className='table table-bordered align-middle'>
                            <thead>
                              <tr className='fw-bold bg-light'>
                                <th>Broj naloga</th>
                                <th>Stavka</th>
                                <th>Broj ponude</th>
                                <th>Šifra</th>
                                <th>Boja</th>
                                <th>Brojevi paketa</th>
                                <th>Napomena</th>
                                <th>
                                  Odaberi Istovar <span className='text-danger'>*</span>
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {groupedRoba.map((item: any, index) => (
                                <tr key={index}>
                                  <td>{item.brojNaloga}</td>

                                  <td>{item.stavka ?? '-'}</td>

                                  <td>{item.brojPonude}</td>

                                  <td>{item.sifra}</td>

                                  <td>{item.boja}</td>

                                  <td>
                                    {Array.isArray(item.paketi)
                                      ? item.paketi.join(', ')
                                      : item.paketi}
                                  </td>

                                  <td style={{minWidth: '250px'}}>
                                    <input
                                      type='text'
                                      className='form-control form-control-solid'
                                      placeholder='Napomena'
                                      value={item.napomena ?? ''}
                                      onChange={(e) => {
                                        const updated = groupedRobaByTruck.map(
                                          (truckRows, truckIndex) =>
                                            truckIndex === selectedTruckIndex
                                              ? truckRows.map((row, rowIndex) =>
                                                  rowIndex === index
                                                    ? {...row, napomena: e.target.value}
                                                    : row
                                                )
                                              : truckRows
                                        )

                                        setGroupedRobaByTruck(updated)
                                      }}
                                    />
                                  </td>

                                  <td style={{minWidth: '160px'}}>
                                    <select
                                      className='form-control form-control-solid'
                                      value={item.istovar ?? ''}
                                      onChange={(e) => {
                                        const updated = groupedRobaByTruck.map(
                                          (truckRows, truckIndex) =>
                                            truckIndex === selectedTruckIndex
                                              ? truckRows.map((row, rowIndex) =>
                                                  rowIndex === index
                                                    ? {...row, istovar: e.target.value}
                                                    : row
                                                )
                                              : truckRows
                                        )

                                        setGroupedRobaByTruck(updated)
                                      }}
                                    >
                                      <option value=''>Odaberi</option>
                                      <option value='Istovar 1'>Istovar 1</option>
                                      <option value='Istovar 2'>Istovar 2</option>
                                    </select>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>

                    {/* ------------------------------------------------ */}
                    {/* PREVOZ */}
                    {/* ------------------------------------------------ */}

                    <div className='col-md-12 mt-10'>
                      <h3 className='fw-bolder mb-5'>Informacije o prevozu</h3>
                    </div>

                    <div className='col-md-4'>
                      <label className='form-label fw-bold'>Ime i prezime vozača</label>

                      <div className='position-relative'>
                        <div className='input-group'>
                          <input
                            type='text'
                            className='form-control'
                            value={vozacIme}
                            readOnly={Boolean(selectedVozac)}
                            onChange={(e) => {
                              setVozacIme(e.target.value)
                              setSelectedVozac(null)
                            }}
                          />

                          {selectedVozac && (
                            <button
                              type='button'
                              className='btn btn-light'
                              onClick={clearSelectedVozac}
                            >
                              Promijeni
                            </button>
                          )}
                        </div>

                        {!selectedVozac && vozacIme.trim().length >= 3 && (
                          <div
                            className='position-absolute start-0 end-0 bg-white border rounded shadow-sm mt-1'
                            style={{zIndex: 1060, maxHeight: 260, overflowY: 'auto'}}
                          >
                            {vozaciLoading ? (
                              <div className='px-4 py-3 text-muted'>Pretraga vozaca...</div>
                            ) : vozaciOptions.length > 0 ? (
                              vozaciOptions.map((vozac: any, index: number) => (
                                <button
                                  key={vozac?.PartnerId ?? vozac?.Id ?? index}
                                  type='button'
                                  className='btn btn-white w-100 text-start px-4 py-3 border-bottom'
                                  onClick={() => selectVozac(vozac)}
                                >
                                  <div className='fw-bold'>
                                    {vozac?.ImePrezimeVozaca ?? vozac?.PartnerNaziv ?? '-'}
                                  </div>
                                  <div className='text-muted small'>
                                    {[
                                      vozac?.PartnerMobitel,
                                      vozac?.RegistracijaKamiona ?? vozac?.Registracija,
                                    ]
                                      .filter(Boolean)
                                      .join(' | ')}
                                  </div>
                                </button>
                              ))
                            ) : vozaciSearchTouched ? (
                              <div className='px-4 py-3'>
                                <div className='text-muted mb-3'>Nema pronadjenih vozaca.</div>
                                <button
                                  type='button'
                                  className='btn btn-sm btn-primary'
                                  onClick={() => navigate('/sifarnici/partneri/dodaj')}
                                >
                                  Dodaj vozaca
                                </button>
                              </div>
                            ) : null}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='col-md-4'>
                      <label className='form-label fw-bold'>Vozac Firma</label>

                      <input
                        type='text'
                        className='form-control'
                        value={vozacFirma}
                        onChange={(e) => setVozacFirma(e.target.value)}
                      />
                    </div>

                    <div className='col-md-4'>
                      <label className='form-label fw-bold'>Tel</label>

                      <input
                        type='text'
                        className='form-control'
                        value={vozacTel}
                        onChange={(e) => setVozacTel(e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Reg oznaka kamiona</label>

                      <input
                        type='text'
                        className='form-control'
                        value={regKamion}
                        onChange={(e) => setRegKamion(e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Reg oznaka prikolice</label>

                      <input
                        type='text'
                        className='form-control'
                        value={regPrikolica}
                        onChange={(e) => setRegPrikolica(e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>
                        Datum utovara <span className='text-danger'>*</span>
                      </label>

                      <input
                        type='date'
                        aria-label='Datum utovara'
                        aria-required='true'
                        className='form-control'
                        value={datumUtovara}
                        onChange={(e) => setDatumUtovara(e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Vrijeme utovara</label>

                      <input
                        type='time'
                        className='form-control'
                        value={vrijemeUtovara}
                        onChange={(e) => setVrijemeUtovara(e.target.value)}
                      />
                    </div>

                    <div className='col-md-12 mt-10'>
                      <h3 className='fw-bolder mb-5'>Cijena transporta</h3>

                      <div className='row g-6'>
                        <div className='col-md-6'>
                          <label className='form-label fw-bold'>BAM</label>

                          <input
                            type='number'
                            step='0.01'
                            className='form-control'
                            value={ugovorenaCijenaBam}
                            onChange={(e) => handleUgovorenaCijenaBamChange(e.target.value)}
                          />
                        </div>

                        <div className='col-md-6'>
                          <label className='form-label fw-bold'>EUR</label>

                          <input
                            type='number'
                            step='0.01'
                            className='form-control'
                            value={ugovorenaCijenaEur}
                            onChange={(e) => handleUgovorenaCijenaEurChange(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='col-md-12 mt-10'>
                      <label className='form-label fw-bold'>Fakturisati transport</label>

                      <select
                        className='form-control'
                        value={fakturisatiTransport}
                        onChange={(e) => {
                          setFakturisatiTransport(e.target.value)

                          if (e.target.value !== 'DA') {
                            setFakturisatiTransportNalog('')
                          }
                        }}
                      >
                        <option value=''>Odaberi</option>
                        <option value='DA'>DA</option>
                        <option value='NE'>NE</option>
                      </select>
                    </div>

                    {fakturisatiTransport === 'DA' && (
                      <div className='col-md-12'>
                        <label className='form-label fw-bold'>Broj naloga za fakturisati</label>

                        <input
                          type='text'
                          className='form-control'
                          value={fakturisatiTransportNalog}
                          onChange={(e) => setFakturisatiTransportNalog(e.target.value)}
                        />
                      </div>
                    )}

                    <div className='col-md-12 mt-10'>
                      <label className='form-label fw-bold'>Dodatni utovar robe</label>

                      <select
                        className='form-control'
                        value={dodatniUtovarRobe}
                        onChange={(e) => {
                          setDodatniUtovarRobe(e.target.value)

                          if (e.target.value !== 'DA') {
                            setBrojNalogaDodatniUtovarRobe('')
                          }
                        }}
                      >
                        <option value=''>Odaberi</option>
                        <option value='DA'>DA</option>
                        <option value='NE'>NE</option>
                      </select>
                    </div>

                    {dodatniUtovarRobe === 'DA' && (
                      <div className='col-md-12'>
                        <label className='form-label fw-bold'>
                          Broj naloga za dodatni utovar robe
                        </label>

                        <input
                          type='text'
                          className='form-control'
                          value={brojNalogaDodatniUtovarRobe}
                          onChange={(e) => setBrojNalogaDodatniUtovarRobe(e.target.value)}
                        />
                      </div>
                    )}

                    {/* ------------------------------------------------ */}
                    {/* IZVOZ */}
                    {/* ------------------------------------------------ */}

                    <div className='col-md-12 mt-10'>
                      <label className='form-label fw-bold'>Vrsta transporta</label>

                      <select
                        className='form-control'
                        value={transport}
                        onChange={(e) => {
                          setTransport(e.target.value)

                          if (e.target.value !== 'ino') {
                            setCarisnkiPostupak('')
                          }
                        }}
                      >
                        <option value=''>Odaberi</option>
                        <option value='domaci'>Domaci</option>
                        <option value='ino'>Ino</option>
                      </select>
                    </div>

                    <div className='col-md-12 mt-10'>
                      <h3 className='fw-bolder mb-5'>Dodatne informacije o prevozu za izvoz</h3>
                    </div>

                    <div className='col-md-6'>
                      <div className='row g-6'>
                        <div className='col-md-12'>
                          <label className='form-label fw-bold'>Granični prelaz</label>

                          <input
                            type='text'
                            className='form-control'
                            value={granicniPrelaz}
                            onChange={(e) => setGranicniPrelaz(e.target.value)}
                          />
                        </div>

                        <div className='col-md-12'>
                          <label className='form-label fw-bold'>
                            Broj lične karte / pasoša vozača
                          </label>

                          <input
                            type='text'
                            className='form-control'
                            value={brojPasosa}
                            onChange={(e) => setBrojPasosa(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    {transport === 'ino' && (
                      <div className='col-md-6'>
                        <label className='form-label fw-bold'>Carinski postupak</label>

                        <div className='d-flex gap-10 flex-wrap'>
                          <label className='form-check form-check-custom form-check-solid'>
                            <input
                              className='form-check-input'
                              type='radio'
                              name='CarisnkiPostupak'
                              value='pojednostavljeni izvoz'
                              checked={carisnkiPostupak === 'pojednostavljeni izvoz'}
                              onChange={(e) => setCarisnkiPostupak(e.target.value)}
                            />
                            <span className='form-check-label'>pojednostavljeni izvoz</span>
                          </label>

                          <label className='form-check form-check-custom form-check-solid'>
                            <input
                              className='form-check-input'
                              type='radio'
                              name='CarisnkiPostupak'
                              value='redovni izvoz'
                              checked={carisnkiPostupak === 'redovni izvoz'}
                              onChange={(e) => setCarisnkiPostupak(e.target.value)}
                            />
                            <span className='form-check-label'>redovni izvoz</span>
                          </label>
                        </div>
                      </div>
                    )}

                    <div className='col-md-12'>
                      <label className='form-label fw-bold'>E-mail za slanje dokumentacije</label>

                      <input
                        type='text'
                        className='form-control'
                        value={emailDokumentacija}
                        onChange={(e) => setEmailDokumentacija(e.target.value)}
                      />

                      <div className='d-flex gap-3 mt-3 flex-wrap'>
                        {kontaktOsobe
                          .filter((kontakt) => kontakt.email)
                          .map((kontakt, index) => (
                            <button
                              key={index}
                              type='button'
                              className='btn btn-light-primary btn-sm'
                              onClick={() => toggleEmail(kontakt.email)}
                            >
                              {kontakt.ime}
                            </button>
                          ))}
                      </div>
                    </div>

                    {/* ------------------------------------------------ */}
                    {/* NAPOMENE */}
                    {/* ------------------------------------------------ */}

                    <div className='col-md-12'>
                      <label className='form-label fw-bold'>Dodatne napomene</label>

                      <textarea
                        className='form-control'
                        rows={4}
                        value={napomene}
                        onChange={(e) => setNapomene(e.target.value)}
                      />
                    </div>

                    {/* ------------------------------------------------ */}
                    {/* ISTOVAR */}
                    {/* ------------------------------------------------ */}

                    <div className='col-md-12 d-none'>
                      <label className='form-label fw-bold'>Adresa istovara</label>

                      <textarea
                        className='form-control'
                        rows={3}
                        value={adresaIstovara}
                        onChange={(e) => setAdresaIstovara(e.target.value)}
                      />
                    </div>

                    <div className='col-md-6 d-none'>
                      <label className='form-label fw-bold'>Kontakt osoba</label>

                      <input
                        type='text'
                        className='form-control'
                        value={kontaktIstovar}
                        onChange={(e) => setKontaktIstovar(e.target.value)}
                      />
                    </div>

                    <div className='col-md-6 d-none'>
                      <label className='form-label fw-bold'>Telefon</label>

                      <input
                        type='text'
                        className='form-control'
                        value={telefonIstovar}
                        onChange={(e) => setTelefonIstovar(e.target.value)}
                      />
                    </div>
                  </div>
                </fieldset>

                {/* FOOTER */}

                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={onClose}
                    disabled={saving}
                  >
                    Close
                  </button>

                  {/* ------------------------------------------------ */}
                  {/* PDF */}
                  {/* ------------------------------------------------ */}

                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={generatePdf}
                    disabled={saving}
                  >
                    {saving ? 'Kreiranje...' : 'Generiši PDF'}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className='modal-backdrop fade show'></div>
        </>
      )}
    </>
  )
}

export default NajavaUtovaraModal
